<div class="gestion-pdp" [hidden]="view==='stepper'">
	<pannel [title]="'Recherche'" [expandable]="true" [folded]="true">
		<pdp-search (onApplyFilters)="filterResults($event)"></pdp-search> 
	</pannel>
	
	<pannel [title]="'Liste des plans de prévention'"> 
		<liste-plan-preventions
			(pdpForEdit)="editThisPdp($event)"
			[refreshCommands]="initListCommands"
			[filterCommands]="searchListCommands">
		</liste-plan-preventions> 
	</pannel>
</div>
<plan-prevention-details [editCommands]="editCommands"
	(viewChange)="changeView($event)" [hidden]="view==='list'">
</plan-prevention-details>